import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import LiveHelpRoundedIcon from '@mui/icons-material/LiveHelpRounded';
import { getPagesList } from '#component/user/pages';
import DrawerLocalStorage from '#utils/drawer-local-storage';
import { whitelabel } from '#config/whitelabel';
import SideList from './side-list';
import propTypes from './prop-types';
import { StyledDrawer, SupportButton } from './styles';
import { toggleRootContainerClass } from '#helper';

const AppDrawer = ({ account, socket }) => {
  const projects = useSelector(s => s.account.directProjects, shallowEqual);
  const [expanded, setExpanded] = useState(DrawerLocalStorage.getDrawerState());

  useEffect(() => {
    const drawerState = DrawerLocalStorage.getDrawerState();
    toggleRootContainerClass({ drawerState });
  }, []);

  const toggleDrawer = () => {
    setExpanded(prevState => {
      const newState = !prevState;
      toggleRootContainerClass({ drawerState: newState, withTransition: true });
      DrawerLocalStorage.setDrawerState(newState);
      return newState;
    });
  };

  const rootProject = projects?.find(p => p.level === 0);
  const pagesList = getPagesList(account.userType, account.id, rootProject);
  const iconRotateAngle = expanded ? 0 : 180;

  const openSupportPage = () => window.open('https://www.tec4med.com/support/', '_blank', 'noreferrer');
  const nonWLDomain = whitelabel.getName().includes('tracking.tec4med.com');

  return (
    <div>
      <IconButton
        color="inherit"
        aria-label="Menu"
        onClick={toggleDrawer}
        style={{ transform: `rotate(${iconRotateAngle}deg)` }}
      >
        <ChevronLeftIcon style={{ color: '#FFF' }} />
      </IconButton>
      <StyledDrawer
        open={true}
        variant="permanent"
      >
        <div
          tabIndex={0}
          role="button"
          aria-label="Menu"
        >
          <SideList
            socket={socket}
            expanded={expanded}
            toggleDrawer={toggleDrawer}
            pagesList={pagesList}
          />
        </div>
      </StyledDrawer>
      {nonWLDomain ?
        <SupportButton
          size="small"
          aria-label="Open support page"
          expanded={expanded}
          onClick={openSupportPage}
        >
          <LiveHelpRoundedIcon />
          <span>Help</span>
        </SupportButton> : null }
    </div>
  );
};

AppDrawer.propTypes = propTypes;

export default AppDrawer;
